import "./index.js";
const get_iban_info = async (event, iban) => {
  if (!iban) {
    return {};
  }
  try {
    const response = await event.fetch(`https://openiban.com/validate/${iban}?getBIC=true&validateBankCode=true`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (response.ok) {
      return await response.json();
    }
  } catch (e) {
    console.error("Error fetching IBAN info", e);
  }
  return {};
};
const reference_cache = {};
const get_reference = async (event, type) => {
  if (!reference_cache[type]) {
    try {
      const response = await event.fetch(`$api/hr/reference/${type}`, {
        method: "GET",
        headers: event.locals.fetchAuthHeaders
      });
      if (response.ok) {
        reference_cache[type] = await response.json();
      }
    } catch (e) {
      console.error("Error fetching reference", e);
    }
  }
  return reference_cache[type] || [];
};
const get_data = async (event) => {
  let parent = await event.parent();
  return {
    lazy_iban_info: get_iban_info(event, parent.employee.bankAccount?.iban),
    lazy_health_insurances: get_reference(event, "Krankenkassen"),
    lazy_tax_brackets: get_reference(event, "Steuerklassen"),
    lazy_religious_denoms: get_reference(event, "Kirchensteuer"),
    lazy_nationalities: get_reference(event, "Staatsangehoerigkeiten"),
    lazy_graduations: get_reference(event, "Schulabschluss"),
    lazy_group_status: get_reference(event, "Gruppen")
  };
};
export {
  get_data as g
};
//# sourceMappingURL=get_data.js.map
